export default __webpack_public_path__ + "static/CWG22-Group_or_individual-56b31039809ae781d2e75f86fe79c036.jpeg";